import styled from "styled-components";
import {
  aIAxiosInstance,
  getTooltip,
  saveAiPostIdea,
  updateTooltip,
} from "api";
import Loader from "components/global/Loader";
import { connect } from "react-redux";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";

const Wrapper = styled.div`
  min-height: 50vh;
`;

const DashboardCreation = ({
  onboarding_state,
  user,
  baseUrl,
  active_account,
  user_token,
  brands,
}) => {
  const history = useHistory();
  const isEven = user.id % 2 === 0;

  const handleCompleteOnboarding = async () => {
    try {
      const res = await updateTooltip({
        ...onboarding_state,
        onboarding_completed: true,
      });
      if (res.data?.status === true) {
        await getTooltip();
      }
      return res;
    } catch (error) {
      throw error;
    }
  };

  const handleSaveIdeas = async (ideas) => {
    const postIdeas = ideas?.map((idea) => {
      return {
        topic: idea.topic_idea,
        idea: idea.post_idea,
        // caption: {
        //   captions: [{ type: "base", caption: idea.caption }],
        // },
      };
    });
    const data = {
      content: postIdeas,
    };

    try {
      const res = await saveAiPostIdea(data);
      if (res.data.status === true) {
        const onboardingRes = await handleCompleteOnboarding();
        if (onboardingRes.data?.status === true) {
          history.push("/dashboard/ai-assistant", { newUser: true });
        }
      }
    } catch (err) {
      await handleCompleteOnboarding();
      history.replace("/dashboard/home");
    }
  };

  // GENERATE POST IDEAS AND REDIRECT TO IDEAS PAGE
  const handleGeneratePostIdeas = async () => {
    const task = "generate_new_ideas_and_caption";
    const data = {
      // task: task,
      brand_name: brands[0].name,
      brand_category: brands[0].category,
    };

    try {
      const res = await aIAxiosInstance.post(task, data, {
        headers: {
          "Content-Type": "application/json",
          "X-USER": user_token,
          "X-ACC-ID": active_account?.id,
        },
      });
      const postIdeas = res.data.post_ideas;

      if (postIdeas) {
        handleSaveIdeas(postIdeas);
      } else {
        // end onboarding and go to dashboard
        const onboardingRes = await handleCompleteOnboarding();
        if (onboardingRes.data?.status === true) {
          history.replace("/dashboard/home");
        }
      }
    } catch (err) {
      // end onboarding and go to dashboard if error occurs
      await handleCompleteOnboarding();
      history.replace("/dashboard/home");
    }
  };

  // GENERATE POST CAPTION AND REDIRECT TO CREATE POST PAGE
  const handleGenerateCaption = async () => {
    const task = "generate_insta_caption";
    const data = {
      // task: task,
      brand_name: brands[0].name,
      brand_category: brands[0].category,
    };

    try {
      const res = await aIAxiosInstance.post(task, data, {
        headers: {
          "Content-Type": "application/json",
          "X-USER": user_token,
          "X-ACC-ID": active_account?.id,
        },
      });
      const caption = res.data?.instagram_caption;
      if (caption) {
        // end onboarding and go to create post page
        localStorage.setItem("free_gift_caption", caption);
        const onboardingRes = await handleCompleteOnboarding();
        if (onboardingRes.data?.status === true) {
          history.replace(
            "/dashboard/posts/calendar-view?post_action=create_post&isNewUser=true"
          );
        }
      } else {
        // end onboarding and go to dashboard
        const onboardingRes = await handleCompleteOnboarding();
        if (onboardingRes.data?.status === true) {
          history.replace("/dashboard/home");
        }
      }
    } catch (err) {
      // end onboarding and go to dashboard if error occurs
      await handleCompleteOnboarding();
      history.replace("/dashboard/home");
    }
  };

  useEffect(() => {
    handleGeneratePostIdeas();
    // eslint-disable-next-line
  }, []);

  // useEffect(() => {
  //   if (isEven) {
  //     handleGenerateCaption();
  //   } else {
  //     handleGeneratePostIdeas();
  //   }
  //   // eslint-disable-next-line
  // }, [isEven]);

  return (
    <Wrapper>
      <div className="centralize">
        <Loader />
        <p className="textCenter">Creating dashboard...</p>
      </div>
    </Wrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    brands: state.brands,
    onboarding_state: state.guided_tours,
    user: state.user,
    baseUrl: state.ai_base_url,
    user_token: state.user_token,
    active_account: state.active_account,
  };
};

export default connect(mapStateToProps)(DashboardCreation);
